import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSearchHeaderStyles = (height, backgroundColor) => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    viewStyle: {
      flexDirection: 'row',
      alignItems: 'center',
      height: height !== null && height !== void 0 ? height : 70,
      width: '100%',
      paddingHorizontal: spacing.SPACING_20,
      backgroundColor
    },
    leftCtaStyle: {
      flex: 0.1,
      alignSelf: 'center',
      marginStart: spacing.SPACING_4,
      marginEnd: spacing.SPACING_16
    },
    searchContainerStyle: {
      flex: 0.9
    }
  });
};